import { isArray } from 'util';
import { UserActivity } from '../user-activity';
import { parseNumber } from '../../utils/number.utils';

export class UserActivityBuilder {
  static fromJson(json) {
    return (json)
      ? new UserActivity(
        json.hash,
        json.name,
        json.erpTask,
        json.erpTaskName,
        parseNumber(json.typeCode),
        json.typeName,
        json.typeMachine
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(UserActivityBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-activity.builder.ts